document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("offerModel");

    if (!modal) {
        return;
    }

    const visitCountKey = "offerPopupVisitCount";
    const sessionKey = "offerPopupSession";
    const handledVisitKey = "offerPopupLastHandledVisit";

    let visitCount = parseInt(localStorage.getItem(visitCountKey), 10) || 0;

    /*
     * Count only once per browser session.
     */
    if (!sessionStorage.getItem(sessionKey)) {
        visitCount++;

        localStorage.setItem(visitCountKey, visitCount);
        sessionStorage.setItem(sessionKey, "1");
    }

    /*
     * Show on visit:
     * 1, 6, 11, 16, ...
     */
    const shouldShow =
        visitCount === 1 ||
        (visitCount > 1 && visitCount % 5 === 1);

    if (!shouldShow) {
        return;
    }

    /*
     * If this particular popup visit has already been handled,
     * don't show it again.
     */
    const lastHandledVisit =
        parseInt(localStorage.getItem(handledVisitKey), 10) || 0;

    if (lastHandledVisit === visitCount) {
        return;
    }

    showModal();

    /*
     * Close button
     */
    const closeButton = modal.querySelector(".btn-close");

    if (closeButton) {
        closeButton.addEventListener("click", function () {
            handlePopup();
        });
    }

    /*
     * Any popup button/link
     */
    const popupActions = modal.querySelectorAll(".popup-action");

    popupActions.forEach(function (button) {
        button.addEventListener("click", function () {
            handlePopup();
        });
    });

    function handlePopup() {
        localStorage.setItem(handledVisitKey, visitCount);
        closeModal();
    }

    function showModal() {
        modal.style.display = "block";
        modal.classList.add("show");
        modal.removeAttribute("aria-hidden");

        if (!document.getElementById("modalBackdrop")) {
            const backdrop = document.createElement("div");

            backdrop.className = "modal-backdrop fade show";
            backdrop.id = "modalBackdrop";

            document.body.appendChild(backdrop);
        }

        document.body.classList.add("modal-open");
    }

    function closeModal() {
        modal.classList.remove("show");
        modal.style.display = "none";

        const backdrop = document.getElementById("modalBackdrop");

        if (backdrop) {
            backdrop.remove();
        }

        document.body.classList.remove("modal-open");
    }
});
